export default {
    "address": "0xEd1D3C9E478B1Dc307b4522CD0e397625CDFc39E",
    "abi": [{
        "inputs": [{
            "internalType": "address",
            "name": "initialOwner",
            "type": "address"
        }, {"internalType": "contract IVault", "name": "_vault", "type": "address"}],
        "stateMutability": "nonpayable",
        "type": "constructor"
    }, {"inputs": [], "name": "InvalidReserves", "type": "error"}, {
        "inputs": [],
        "name": "SafeCastOverflow",
        "type": "error"
    }, {
        "anonymous": false,
        "inputs": [{"indexed": true, "internalType": "address", "name": "user", "type": "address"}, {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
        }],
        "name": "OwnershipTransferred",
        "type": "event"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "checkMarginPositionLiquidate",
        "outputs": [{"internalType": "bool", "name": "liquidated", "type": "bool"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "internalType": "bool",
            "name": "zeroForOne",
            "type": "bool"
        }, {"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
            "internalType": "bool",
            "name": "dynamicFee",
            "type": "bool"
        }],
        "name": "getAmountIn",
        "outputs": [{"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
            "internalType": "uint24",
            "name": "fee",
            "type": "uint24"
        }, {"internalType": "uint256", "name": "feeAmount", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "internalType": "bool",
            "name": "zeroForOne",
            "type": "bool"
        }, {"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
            "internalType": "bool",
            "name": "dynamicFee",
            "type": "bool"
        }],
        "name": "getAmountOut",
        "outputs": [{"internalType": "uint256", "name": "amountOut", "type": "uint256"}, {
            "internalType": "uint24",
            "name": "fee",
            "type": "uint24"
        }, {"internalType": "uint256", "name": "feeAmount", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "internalType": "bool",
            "name": "borrowForOne",
            "type": "bool"
        }],
        "name": "getBorrowAPR",
        "outputs": [{"internalType": "uint256", "name": "rate", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "internalType": "bool",
            "name": "marginForOne",
            "type": "bool"
        }],
        "name": "getBorrowRate",
        "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "internalType": "bool",
            "name": "borrowForOne",
            "type": "bool"
        }, {"internalType": "uint256", "name": "inputAmount", "type": "uint256"}],
        "name": "getLendingAPR",
        "outputs": [{"internalType": "uint256", "name": "apr", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "getLiquidateRepayAmount",
        "outputs": [{"internalType": "uint256", "name": "repayAmount", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
        "name": "getMaxDecrease",
        "outputs": [{"internalType": "uint256", "name": "maxAmount", "type": "uint256"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}, {
            "internalType": "bool",
            "name": "zeroForOne",
            "type": "bool"
        }, {"internalType": "uint256", "name": "amountIn", "type": "uint256"}, {
            "internalType": "uint256",
            "name": "amountOut",
            "type": "uint256"
        }],
        "name": "getPoolFees",
        "outputs": [{"internalType": "uint24", "name": "_fee", "type": "uint24"}, {
            "internalType": "uint24",
            "name": "_marginFee",
            "type": "uint24"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}],
        "name": "getPoolStateInfo",
        "outputs": [{
            "components": [{
                "internalType": "uint128",
                "name": "totalSupply",
                "type": "uint128"
            }, {"internalType": "uint32", "name": "lastUpdated", "type": "uint32"}, {
                "internalType": "uint24",
                "name": "lpFee",
                "type": "uint24"
            }, {"internalType": "uint24", "name": "marginFee", "type": "uint24"}, {
                "internalType": "uint24",
                "name": "protocolFee",
                "type": "uint24"
            }, {"internalType": "uint128", "name": "realReserve0", "type": "uint128"}, {
                "internalType": "uint128",
                "name": "realReserve1",
                "type": "uint128"
            }, {"internalType": "uint128", "name": "mirrorReserve0", "type": "uint128"}, {
                "internalType": "uint128",
                "name": "mirrorReserve1",
                "type": "uint128"
            }, {"internalType": "uint128", "name": "pairReserve0", "type": "uint128"}, {
                "internalType": "uint128",
                "name": "pairReserve1",
                "type": "uint128"
            }, {"internalType": "uint128", "name": "truncatedReserve0", "type": "uint128"}, {
                "internalType": "uint128",
                "name": "truncatedReserve1",
                "type": "uint128"
            }, {"internalType": "uint128", "name": "lendReserve0", "type": "uint128"}, {
                "internalType": "uint128",
                "name": "lendReserve1",
                "type": "uint128"
            }, {"internalType": "uint128", "name": "interestReserve0", "type": "uint128"}, {
                "internalType": "uint128",
                "name": "interestReserve1",
                "type": "uint128"
            }, {
                "internalType": "uint256",
                "name": "borrow0CumulativeLast",
                "type": "uint256"
            }, {
                "internalType": "uint256",
                "name": "borrow1CumulativeLast",
                "type": "uint256"
            }, {
                "internalType": "uint256",
                "name": "deposit0CumulativeLast",
                "type": "uint256"
            }, {"internalType": "uint256", "name": "deposit1CumulativeLast", "type": "uint256"}],
            "internalType": "struct LikwidHelper.PoolStateInfo",
            "name": "stateInfo",
            "type": "tuple"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "id", "type": "bytes32"}],
        "name": "getReleasedLiquidity",
        "outputs": [{"internalType": "uint128", "name": "", "type": "uint128"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "poolId", "type": "bytes32"}],
        "name": "getStageLiquidities",
        "outputs": [{"internalType": "uint128[][]", "name": "liquidities", "type": "uint128[][]"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "PoolId", "name": "id", "type": "bytes32"}],
        "name": "getStageState",
        "outputs": [{"internalType": "uint24", "name": "stageSize", "type": "uint24"}, {
            "internalType": "uint24",
            "name": "stageLeavePart",
            "type": "uint24"
        }, {"internalType": "uint24", "name": "stageDuration", "type": "uint24"}, {
            "internalType": "uint256",
            "name": "lastStageTimestamp",
            "type": "uint256"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "minMarginLevels",
        "outputs": [{"internalType": "uint24", "name": "minMarginLevel", "type": "uint24"}, {
            "internalType": "uint24",
            "name": "minBorrowLevel",
            "type": "uint24"
        }],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [],
        "name": "owner",
        "outputs": [{"internalType": "address", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }, {
        "inputs": [{"internalType": "contract IVault", "name": "_vault", "type": "address"}],
        "name": "setVault",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [{"internalType": "address", "name": "newOwner", "type": "address"}],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    }, {
        "inputs": [],
        "name": "vault",
        "outputs": [{"internalType": "contract IVault", "name": "", "type": "address"}],
        "stateMutability": "view",
        "type": "function"
    }]
}